// @flow
import React, { Component } from 'react';
import {
  SearchIcon,
  SearchInput,
  SearchStaticDiv,
  XIcon
} from './SearchStaticStyles';

type Props = {
  handleSearchChange: (value: string) => void,
  searchValue: string,
  disabled?: boolean,
  placeholder: string,
  hideBorderBottom?: boolean,
  placeholder: string,
  hideBorderBottom?: boolean,
  disabled: boolean
};

export default class SearchStatic extends Component<Props> {
  handleChange = (event: SyntheticKeyboardEvent<HTMLInputElement>) => {
    this.props.handleSearchChange(event.currentTarget.value);
  };

  clearSearch = () => {
    if (this.props.disabled) {
      return;
    } else {
      this.props.handleSearchChange('');
    }
  };

  render() {
    const active = this.props.searchValue;
    return (
      <SearchStaticDiv styled={{ active }} disabled={this.props.disabled}>
        <SearchIcon active={active} disabled={this.props.disabled} />
        <SearchInput
          onChange={this.handleChange}
          value={this.props.searchValue}
          id="filter-search-input"
          placeholder={this.props.placeholder}
          disabled={this.props.disabled}
          hideBorderBottom={this.props.hideBorderBottom}
        />
        {active && (
          <XIcon disabled={this.props.disabled} onClick={this.clearSearch} />
        )}
      </SearchStaticDiv>
    );
  }
}
